module.exports = __webpack_public_path__ + "img/menonv.cddc3438.jpg";